<template>
  <div>
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        城市运营
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索名称/编号/电话/地址"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="osg.has('Operations,export')"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:code|string#or': searchValue,
                'fpi-regex:phone|string#or': searchValue,
                'fpi-regex:address|string#or': searchValue,
                'in:state|array-integer#and': '0,1',
                beanName: 'operation',
                title: '城市运营'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="configClick(scope.row)">
                    配置
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="城市运营" :visible.sync="openDetail" :close-on-click-modal="false">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="config.data.name + '配置'"
      :visible.sync="config.show"
      :close-on-click-modal="false"
      width="1000px"
    >
      <div
        class="configList-wrapper"
        style="
            height: 400px;
            overflow: auto;
            border: 1px solid #DCDFE6;
            padding: 10px;
            box-sizing: border-box;
            border-radius: 3px;
          "
      >
        <div v-for="(item, index) in config.list" :key="index" class="c-m-b-10">
          <div class="c-flex c-flex-item c-flex-between">
            <el-input v-model="item.key" placeholder="请输入key" style="flex:1">
              <template slot="append">
                <el-select style="width:120px" v-model="item.type" placeholder="请选择类型">
                  <el-option
                    v-for="item in [
                      { label: 'object', value: '' },
                      { label: 'number', value: 'number' },
                      { label: 'string', value: 'string' }
                    ]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-input>
            <div style="flex: 2;" class="c-m-l-10 c-flex c-item-center c-flex-around">
              <el-input v-model="item.value" placeholder="请输入value">
                <el-button slot="append">
                  <el-popover placement="right" width="400" trigger="click">
                    <el-input v-model="item.value" type="textarea" :rows="30"></el-input>
                    <el-button slot="reference" icon="el-icon-zoom-in"></el-button>
                  </el-popover>
                </el-button>
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="c-flex c-flex-between c-item-center">
        <el-button type="primary" @click="addConfigField">新增字段</el-button>
        <div>
          <el-button type="primary" @click="configSave">确 定</el-button>
          <el-button @click="configCancel">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'Operations',
  data() {
    window.$this = this;
    return {
      name: 'operation',
      fpi: { data: [] },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        exts: {}
      },
      rules: this.$util.rules,
      options: {},
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      config: { show: false, data: {}, list: [], formData: {} }
    };
  },
  mounted() {
    this.osg.getFields('operation', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('/basic/operation/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        exts: {}
      };
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        delete this.formData.exts;
        this.osg.ajax('basic/operation/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        });
      }
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doEnable(id) {
      this.osg.ajax('basic/operation/enable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/operation/disable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    configClick(row) {
      this.config.list = [];
      this.config.formData = {};
      this.getDataById(row._id, data => {
        this.config.data = data; // 弹窗内保存城市运营信息
        // 城市运营配置信息在exts字段，将配置信息exts转为数组。
        let exts = data.exts;
        for (let key in exts) {
          this.config.list.push({
            key: key,
            value: typeof exts[key] != 'string' ? JSON.stringify(exts[key]) : exts[key],
            type: typeof exts[key]
          });
        }
        this.config.show = true;
      });
    },
    getDataById(id, callback) {
      this.osg.ajax('/basic/operation/findById.do', { id }, res => {
        if (callback) callback(res.data);
      });
    },
    //新增扩展字段
    addConfigField() {
      this.config.list.push({ key: '', value: '' });
      this.scrollToBottom();
    },
    //控制到底部
    scrollToBottom() {
      this.$nextTick(() => {
        let container = this.$el.querySelector('.configList-wrapper');
        container.scrollTop = container.scrollHeight;
      });
    },
    configSave() {
      this.config.list.map(item => {
        if (item.key && item.value) {
          if (item.type == 'string') {
            item.value = String(item.value);
          } else if (item.type == 'number') {
            item.value = Number(item.value);
          }
          if (this.osg.isJson(item.value)) {
            this.config.formData[item.key.replace(/\s/g, '')] = JSON.parse(item.value);
          } else {
            this.config.formData[item.key.replace(/\s/g, '')] = item.value;
          }
        }
      });
      this.osg.ajax(
        '/basic/operation/upsertExt.do',
        { id: this.config.data._id, data: JSON.stringify(this.config.formData) },
        () => {
          this.osg.toast('保存成功！');
          this.configCancel();
        }
      );
    },
    configCancel() {
      this.config = {
        show: false,
        data: {},
        list: [],
        formData: {}
      };
    }
  }
};
</script>
